// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/arrow-right.js';

import { paths } from '../generated/arrow-right';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('arrow-right', Original, paths);
